import { P2GBox, P2GButton, P2GGrid, P2GIcon } from '@parcel2go/core-ui';
import { ApplierOption } from '../../../lib/helpers/ApplierOption';
import { P2GText } from '@parcel2go/core-ui';
import { GetBulkActionTitle } from './GetBulkActionTitle';
import { GetBulkActionIcon } from './GetBulkActionIcon';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';
import { AppCard } from '~/components/card/app-card';
import { ReactNode } from 'react';

interface props {
  onActionClick: (a: ApplierOption) => void;
  affected?: (action: string) => number;
  action: ApplierOption;
  buttonText?: string;
  label?: ReactNode;
  variant?: 'info' | 'warning' | 'error' | 'success' | 'primary' | 'secondary';
}

export default function ActionCard({ variant, label, buttonText, action, affected, onActionClick }: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const isFix = action.includes(':Add');
  const title = GetBulkActionTitle(t, action);
  const button = isFix ? title.split(' ')[0] : t('SMARTSEND_ACTIONCARD_SELECT_FALLBACK', { defaultValue: 'Select' });
  return (
    <AppCard variant={variant}>
      <P2GBox p={2}>
        <P2GGrid container alignItems="center" gap={2} wrap="nowrap">
          <P2GGrid item>
            <P2GIcon size="sm">{GetBulkActionIcon(action)}</P2GIcon>
          </P2GGrid>
          <P2GGrid item flexGrow={1}>
            {label ?? (
              <P2GText>
                <strong>{title}</strong>
              </P2GText>
            )}
          </P2GGrid>
          {affected && (
            <P2GGrid item textAlign="center">
              <P2GText variant="subtitle2" sx={{ whiteSpace: 'nowrap' }}>
                {affected(action)} x
              </P2GText>
            </P2GGrid>
          )}
          <P2GGrid item>
            <P2GButton
              onClick={() => onActionClick(action)}
              variant={isFix ? 'primary' : 'tertiary'}
              style={{ minWidth: '95px' }}
            >
              {buttonText ?? button}
            </P2GButton>
          </P2GGrid>
        </P2GGrid>
      </P2GBox>
    </AppCard>
  );
}
